<template>
  <div class="tour-arrival">
    <div
      v-for="{ icon, name, title, text } in items"
      :key="icon"
      class="tour-arrival__item"
    >
      <div class="tour-arrival__top">
        <div class="tour-arrival__icon u-flex-shrink-0">
          <svg-inline>
            <icon :icon="icon" />
          </svg-inline>
        </div>
        <div class="font-h2">
          {{ name }}
        </div>
      </div>
      <div v-if="title" class="tour-arrival__title font-semibold">
        {{ title }}
      </div>
      <div class="tour-arrival__text font-text-small u-text-secondary">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
import { format, parse } from "date-fns";
import getDateFnsLocale from "@/assets/js/utils/get-date-fns-locale";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";

export default {
  components: {
    SvgInline,
    Icon,
  },
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    items() {
      const {
        formatDate,
        offer: {
          dateFrom,
          dateTo,
          start_point_time,
          finish_point_time,
          start_point_city,
          finish_point_city,
        },
      } = this;

      const localTimeText = this.$t("serpDetail.arrival.localTime");

      return [
        {
          icon: "rocket-launch",
          name: this.$t("serpDetail.arrival.start"),
          title:
            dateFrom &&
            `${formatDate(dateFrom)}${
              start_point_time ? `, ${start_point_time} (${localTimeText})` : ""
            }`,
          text: start_point_city?.name,
        },
        {
          icon: "rocket-landing",
          name: this.$t("serpDetail.arrival.finish"),
          title:
            dateTo &&
            `${formatDate(dateTo)}${
              finish_point_time
                ? `, ${finish_point_time} (${localTimeText})`
                : ""
            }`,
          text: finish_point_city?.name,
        },
      ];
    },
  },
  methods: {
    formatDate(dateString) {
      return format(parse(dateString, "dd.MM.yyyy", new Date()), "d MMMM", {
        locale: getDateFnsLocale.call(this),
      });
    },
  },
};
</script>

<style lang="scss">
.tour-arrival {
  display: grid;
  grid-gap: 24px;

  @include mixin.size-md-only {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @include mixin.size-xl-min {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  &__top {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  &__icon {
    width: 20px;
    margin-right: 6px;
  }

  &__text {
    margin-top: 4px;
  }
}
</style>
